/*  MUI  */
import { Box, DialogActions } from '@mui/material';

/*  React  */
import React from 'react';

export const ModalFooter = ({ children, ...rest }) => (
    <DialogActions
        sx={{
            backgroundColor: 'modal.backgroundColor.footer',
            paddingX: '24px',
            paddingY: '16px'
        }}
        {...rest}
    >
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
        >
            {children}
        </Box>
    </DialogActions>
);
